import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import confetti from "canvas-confetti";
import * as anchor from "@project-serum/anchor";
import { LAMPORTS_PER_SOL, PublicKey } from "@solana/web3.js";
import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { GatewayProvider } from "@civic/solana-gateway-react";
import Countdown from "react-countdown";
import { Snackbar, Paper, LinearProgress, Chip } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { Connection } from "@solana/web3.js";
import { toDate, AlertState, getAtaForMint } from "./utils";
import { MintButton } from "./MintButton";
import { MultiMintButton } from "./MultiMintButton";
import { Outlet, Link } from "react-router-dom";
import UnityGame from "./routes/UnityGame";
// import Alert from 'react-popup-alert'
import {
  CandyMachine,
  awaitTransactionSignatureConfirmation,
  getCandyMachineState,
  mintOneToken,
  mintMultipleToken,
  CANDY_MACHINE_PROGRAM,
} from "./candy-machine";
import {
  getParsedNftAccountsByOwner,
  isValidSolanaAddress,
  createConnectionConfig,
} from "@nfteyez/sol-rayz";
const cluster = process.env.REACT_APP_SOLANA_NETWORK!.toString();
const decimals = process.env.REACT_APP_SPL_TOKEN_TO_MINT_DECIMALS
  ? +process.env.REACT_APP_SPL_TOKEN_TO_MINT_DECIMALS!.toString()
  : 9;
const splTokenName = process.env.REACT_APP_SPL_TOKEN_TO_MINT_NAME
  ? process.env.REACT_APP_SPL_TOKEN_TO_MINT_NAME.toString()
  : "TOKEN";

const WalletContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: right;
  background-color: #e6f0ff;
  padding: 12px 10px 0 5px;
  box-shadow: 2px 2px 2px 1px #444;
  border-radius: 0 0 10px 10px;
`;

const WalletAmount = styled.div`
  color: black;
  width: auto;
  padding: 5px 5px 5px 16px;
  min-width: 48px;
  min-height: auto;
  border-radius: 22px;
  background-color: var(--main-text-color);
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),
    0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 500;
  line-height: 1.75;
  text-transform: uppercase;
  border: 0;
  margin: 0;
  display: inline-flex;
  outline: 0;
  position: relative;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  justify-content: flex-start;
  gap: 10px;
`;

const Wallet = styled.ul`
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
`;

const ConnectButton = styled(WalletMultiButton)`
  border-radius: 18px !important;
  padding: 6px 16px;
  // background-color: #4e44ce;
  // background-color: #be419f;
  background: linear-gradient(to right, #d953fe, #430fd5);
  margin: 0 auto;
`;

const NFT = styled(Paper)`
  min-width: 370px;
  margin: 0 auto;
  // padding: 5px 20px 20px 20px;
  // background-color: white !important;
  color: #be419f !important;
  border-radius: 2rem !important;
  flex: 1 1 auto;
  background-size: 100% 100%;
  // width: 30vw;
  padding: 3rem 0;
  background-repeat: no-repeat;
  // width: 60vw;
  background-color: rgba(0, 0, 0, 0) !important;
  box-shadow: none !important;
  /* background-size: cover; */
  // background-size: cover;
  // position:relative;
  // background-color: var(--card-background-color) !important;
  background-image: url("./stone.png");
  // background-size: 50vw;
  // background-repeat: no-repeat; /* Do not repeat the image */
  // background-size: cover; /* Resize the background image to cover the entire container */
  // box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22) !important;
`;

const Card = styled(Paper)`
  display: inline-block;
  background-color: var(--countdown-background-color) !important;
  margin: 5px;
  min-width: 40px;
  border-radius: 2rem !important;
  padding: 24px;
  h1 {
    margin: 0px;
  }
`;

const MintButtonContainer = styled.div`
  button.MuiButton-contained:not(.MuiButton-containedPrimary).Mui-disabled {
    color: #464646;
  }

  button.MuiButton-contained:not(.MuiButton-containedPrimary):hover,
  button.MuiButton-contained:not(.MuiButton-containedPrimary):focus {
    -webkit-animation: pulse 1s;
    animation: pulse 1s;
    box-shadow: 0 0 0 2em rgba(255, 255, 255, 0);
  }

  @-webkit-keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 #ef8f6e;
    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 #ef8f6e;
    }
  }
`;

const SolExplorerLink = styled.a`
  color: var(--title-text-color);
  border-bottom: 1px solid var(--title-text-color);
  font-weight: bold;
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
  outline: none;
  text-decoration: none;
  text-size-adjust: 100%;

  :hover {
    border-bottom: 2px solid var(--title-text-color);
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0px;
  // padding-top: 20px;
  margin-bottom: 20px;
  margin-right: 2%;
  margin-left: 2%;
  margin: 0;
  // position:absolute;
  // z-index:10;
  // top:0;
  text-align: center;
  justify-content: center;
`;

const MintContainer = styled.div`
  margin-top: 2vw;
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 20px;
`;

const DesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: 20px;
`;

const Price = styled(Chip)`
  position: absolute;
  margin: 5px;
  font-weight: bold;
  font-size: 1.2em !important;
  // font-family: "Patrick Hand", cursive !important;
`;

const Image = styled.img`
  // height: 400px;
  width: 70%;
  border-radius: 7px;
  box-shadow: 5px 5px 40px 5px rgba(0, 0, 0, 0.5);
`;

const BorderLinearProgress = styled(LinearProgress)`
  margin: 20px;
  height: 10px !important;
  border-radius: 3rem;
  border: 2px solid white;
  width: 60%;
  margin: auto;
  box-shadow: 5px 5px 40px 5px rgba(0, 0, 0, 0.5);
  background-color: var(--main-text-color) !important;

  > div.MuiLinearProgress-barColorPrimary {
    // background-color: var(--title-text-color) !important;
    background: linear-gradient(to right, #00fb90, #0097b4) !important;
  }

  > div.MuiLinearProgress-bar1Determinate {
    border-radius: 30px !important;
    background-image: linear-gradient(
      270deg,
      rgba(255, 255, 255, 0.01),
      rgba(255, 255, 255, 0.5)
    );
  }
`;

export interface HomeProps {
  candyMachineId: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  txTimeout: number;
  rpcHost: string;
}

const Home = (props: HomeProps) => {
  const [balance, setBalance] = useState<number>();
  const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT
  const [isActive, setIsActive] = useState(false); // true when countdown completes or whitelisted
  const [solanaExplorerLink, setSolanaExplorerLink] = useState<string>("");
  const [itemsAvailable, setItemsAvailable] = useState(0);
  const [itemsRedeemed, setItemsRedeemed] = useState(0);
  const [itemsRemaining, setItemsRemaining] = useState(0);
  const [isSoldOut, setIsSoldOut] = useState(false);
  const [payWithSplToken, setPayWithSplToken] = useState(false);
  const [price, setPrice] = useState(0);
  const [priceLabel, setPriceLabel] = useState<string>("SOL");
  const [whitelistPrice, setWhitelistPrice] = useState(0);
  const [whitelistEnabled, setWhitelistEnabled] = useState(false);
  const [isBurnToken, setIsBurnToken] = useState(false);
  const [whitelistTokenBalance, setWhitelistTokenBalance] = useState(0);
  const [isEnded, setIsEnded] = useState(false);
  const [endDate, setEndDate] = useState<Date>();
  const [isPresale, setIsPresale] = useState(false);
  const [isWLOnly, setIsWLOnly] = useState(false);
  const [readyEnterGame, setReadyEnterGame] = useState(false);
  const [readyMint, setReadyMint] = useState(false);
  const [hasMonopolyNft, setHasMonopolyNft] = useState(false);
  const [nftAddress, setNftAddress] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });

  const wallet = useAnchorWallet();
  const [candyMachine, setCandyMachine] = useState<CandyMachine>();

  const rpcUrl = props.rpcHost;
  const solFeesEstimation = 0.012; // approx of account creation fees

  const refreshCandyMachineState = () => {
    (async () => {
      if (!wallet) return;

      const cndy = await getCandyMachineState(
        wallet as anchor.Wallet,
        props.candyMachineId,
        props.connection
      );

      // console.log("candyMachine", props.candyMachineId);
      setCandyMachine(cndy);
      setItemsAvailable(cndy.state.itemsAvailable);
      setItemsRemaining(cndy.state.itemsRemaining);
      setItemsRedeemed(cndy.state.itemsRedeemed);

      var divider = 1;
      if (decimals) {
        divider = +("1" + new Array(decimals).join("0").slice() + "0");
      }

      // detect if using spl-token to mint
      if (cndy.state.tokenMint) {
        setPayWithSplToken(true);
        // Customize your SPL-TOKEN Label HERE
        // TODO: get spl-token metadata name
        setPriceLabel(splTokenName);
        setPrice(cndy.state.price.toNumber() / divider);
        setWhitelistPrice(cndy.state.price.toNumber() / divider);
      } else {
        setPrice(cndy.state.price.toNumber() / LAMPORTS_PER_SOL);
        setWhitelistPrice(cndy.state.price.toNumber() / LAMPORTS_PER_SOL);
      }
      // fetch whitelist token balance
      if (cndy.state.whitelistMintSettings) {
        setWhitelistEnabled(true);
        setIsBurnToken(cndy.state.whitelistMintSettings.mode.burnEveryTime);
        setIsPresale(cndy.state.whitelistMintSettings.presale);
        setIsWLOnly(
          !isPresale && cndy.state.whitelistMintSettings.discountPrice === null
        );

        if (
          cndy.state.whitelistMintSettings.discountPrice !== null &&
          cndy.state.whitelistMintSettings.discountPrice !== cndy.state.price
        ) {
          if (cndy.state.tokenMint) {
            setWhitelistPrice(
              cndy.state.whitelistMintSettings.discountPrice?.toNumber() /
                divider
            );
          } else {
            setWhitelistPrice(
              cndy.state.whitelistMintSettings.discountPrice?.toNumber() /
                LAMPORTS_PER_SOL
            );
          }
        }

        let balance = 0;
        try {
          const tokenBalance = await props.connection.getTokenAccountBalance(
            (
              await getAtaForMint(
                cndy.state.whitelistMintSettings.mint,
                wallet.publicKey
              )
            )[0]
          );

          balance = tokenBalance?.value?.uiAmount || 0;
        } catch (e) {
          console.error(e);
          balance = 0;
        }
        setWhitelistTokenBalance(balance);
        setIsActive(isPresale && !isEnded && balance > 0);
      } else {
        setWhitelistEnabled(false);
      }

      // end the mint when date is reached
      if (cndy?.state.endSettings?.endSettingType.date) {
        setEndDate(toDate(cndy.state.endSettings.number));
        if (
          cndy.state.endSettings.number.toNumber() <
          new Date().getTime() / 1000
        ) {
          setIsEnded(true);
          setIsActive(false);
        }
      }
      // end the mint when amount is reached
      console.log(cndy);
      if (cndy?.state.endSettings?.endSettingType.amount) {
        let limit = Math.min(
          cndy.state.endSettings.number.toNumber(),
          cndy.state.itemsAvailable
        );
        setItemsAvailable(limit);
        if (cndy.state.itemsRedeemed < limit) {
          setItemsRemaining(limit - cndy.state.itemsRedeemed);
        } else {
          setItemsRemaining(0);
          cndy.state.isSoldOut = true;
          setIsEnded(true);
        }
      } else {
        setItemsRemaining(cndy.state.itemsRemaining);
      }

      if (cndy.state.isSoldOut) {
        setIsActive(false);
      }
    })();
  };

  const renderGoLiveDateCounter = ({ days, hours, minutes, seconds }: any) => {
    return (
      <div>
        <Card elevation={1}>
          <h1>{days}</h1>Days
        </Card>
        <Card elevation={1}>
          <h1>{hours}</h1>
          Hours
        </Card>
        <Card elevation={1}>
          <h1>{minutes}</h1>Mins
        </Card>
        <Card elevation={1}>
          <h1>{seconds}</h1>Secs
        </Card>
      </div>
    );
  };

  const renderEndDateCounter = ({ days, hours, minutes }: any) => {
    let label = "";
    if (days > 0) {
      label += days + " days ";
    }
    if (hours > 0) {
      label += hours + " hours ";
    }
    label += minutes + 1 + " minutes left to MINT.";
    return (
      <div>
        <h3>{label}</h3>
      </div>
    );
  };

  function displaySuccess(mintPublicKey: any, qty: number = 1): void {
    let remaining = itemsRemaining - qty;
    setItemsRemaining(remaining);
    setIsSoldOut(remaining === 0);
    if (isBurnToken && whitelistTokenBalance && whitelistTokenBalance > 0) {
      let balance = whitelistTokenBalance - qty;
      setWhitelistTokenBalance(balance);
      setIsActive(isPresale && !isEnded && balance > 0);
    }
    setItemsRedeemed(itemsRedeemed + qty);
    if (!payWithSplToken && balance && balance > 0) {
      setBalance(
        balance -
          (whitelistEnabled ? whitelistPrice : price) * qty -
          solFeesEstimation
      );
    }
    setSolanaExplorerLink(
      cluster === "devnet" || cluster === "testnet"
        ? "https://solscan.io/token/" + mintPublicKey + "?cluster=" + cluster
        : "https://solscan.io/token/" + mintPublicKey
    );
    throwConfetti();
  }

  function throwConfetti(): void {
    confetti({
      particleCount: 400,
      spread: 70,
      origin: { y: 0.6 },
    });
  }

  function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function mintMany(quantityString: number) {
    if (wallet && candyMachine?.program && wallet.publicKey) {
      const quantity = Number(quantityString);
      const futureBalance =
        (balance || 0) - (whitelistEnabled ? whitelistPrice : price) * quantity;
      const signedTransactions: any = await mintMultipleToken(
        candyMachine,
        wallet.publicKey,
        quantity
      );

      const promiseArray = [];

      for (let index = 0; index < signedTransactions.length; index++) {
        const tx = signedTransactions[index];
        promiseArray.push(
          awaitTransactionSignatureConfirmation(
            tx,
            props.txTimeout,
            props.connection,
            "singleGossip",
            true
          )
        );
      }

      const allTransactionsResult = await Promise.all(promiseArray);
      let totalSuccess = 0;
      let totalFailure = 0;

      for (let index = 0; index < allTransactionsResult.length; index++) {
        const transactionStatus = allTransactionsResult[index];
        if (!transactionStatus?.err) {
          totalSuccess += 1;
        } else {
          totalFailure += 1;
        }
      }

      let retry = 0;
      if (allTransactionsResult.length > 0) {
        let newBalance =
          (await props.connection.getBalance(wallet.publicKey)) /
          LAMPORTS_PER_SOL;

        while (newBalance > futureBalance && retry < 20) {
          await sleep(2000);
          newBalance =
            (await props.connection.getBalance(wallet.publicKey)) /
            LAMPORTS_PER_SOL;
          retry++;
          console.log(
            "Estimated balance (" +
              futureBalance +
              ") not correct yet, wait a little bit and re-check. Current balance : " +
              newBalance +
              ", Retry " +
              retry
          );
        }
      }

      if (totalSuccess && retry < 20) {
        setAlertState({
          open: true,
          message: `Congratulations! Your ${quantity} mints succeeded!`,
          severity: "success",
        });

        // update front-end amounts
        displaySuccess(wallet.publicKey, quantity);
      }

      if (totalFailure || retry === 20) {
        setAlertState({
          open: true,
          message: `Some mints failed! (possibly ${totalFailure}) Wait a few minutes and check your wallet.`,
          severity: "error",
        });
      }

      if (totalFailure === 0 && totalSuccess === 0) {
        setAlertState({
          open: true,
          message: `Mints manually cancelled.`,
          severity: "error",
        });
      }
    }
  }

  async function mintOne() {
    if (wallet && candyMachine?.program && wallet.publicKey) {
      const mint = anchor.web3.Keypair.generate();
      const mintTxId = (
        await mintOneToken(candyMachine, wallet.publicKey, mint)
      )[0];

      let status: any = { err: true };
      if (mintTxId) {
        status = await awaitTransactionSignatureConfirmation(
          mintTxId,
          props.txTimeout,
          props.connection,
          "singleGossip",
          true
        );
      }

      if (!status?.err) {
        setAlertState({
          open: true,
          message: "Congratulations! Mint succeeded!",
          severity: "success",
        });

        // update front-end amounts
        displaySuccess(mint.publicKey);
      } else {
        setAlertState({
          open: true,
          message: "Mint failed! Please try again!",
          severity: "error",
        });
      }
    }
  }

  const startMint = async (quantityString: number) => {
    try {
      setIsMinting(true);
      if (quantityString === 1) {
        await mintOne();
      } else {
        await mintMany(quantityString);
      }
    } catch (error: any) {
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (!error.message) {
          message = "Transaction Timeout! Please try again.";
        } else if (error.message.indexOf("0x138")) {
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setIsMinting(false);
    }
  };
  // const getProvider = () => {
  //   if ("solana" in window) {
  //   const provider = window.solana;
  //   if (provider.isPhantom) {
  //     return provider;
  //    }
  //   }
  // };
  useEffect(() => {
    (async () => {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        console.log("balance is :", balance);
        console.log("public key is", wallet.publicKey.toString());
        const connect = new Connection(rpcUrl);
        const nfts = await getParsedNftAccountsByOwner({
          publicAddress: wallet.publicKey.toString(),
          connection: connect,
        });
        console.log(nfts);

        for (var i = 0; i < nfts.length; i++) {
          if (
            nfts[i].data.name.includes("deMonopoly") &&
            nfts[i].updateAuthority ===
              "F5Kf8tBRiXXY8T6obXTRJjUqmFYeHZ9rzYhqcfDoH9BV"
          ) {
            setNftAddress(nfts[i].mint);
            setWalletAddress(wallet.publicKey.toString());
            // TODO emit event, pass this nft to game
            setHasMonopolyNft(true);
            break;
          }
        }

        setBalance(balance / LAMPORTS_PER_SOL);
      }
    })();
  }, [wallet, props.connection]);

  useEffect(refreshCandyMachineState, [
    wallet,
    props.candyMachineId,
    props.connection,
    isEnded,
    isPresale,
  ]);

  const onClickTwitter = () => {
    window.open("https://twitter.com/deMonopolyNFT");
  };
  const onClickDiscord = () => {
    window.open("https://discord.gg/xqqQR6mKvr");
  };
  const mintContainerRef = useRef(null);
  const enterButtonRef = useRef(null);

  const unityGameRef = useRef<any>(null);
  const clickEnter = () => {
    console.log("clicked enter");
    if (unityGameRef.current && nftAddress) {
      unityGameRef.current.login(nftAddress, walletAddress);
      setReadyEnterGame(true);
    } else if (!walletAddress) {
      setAlertState({
        open: true,
        message: `Please connect your wallet first!`,
        severity: "error",
      });
      console.log("no wallet connected!");
    } else if (nftAddress) {
      setAlertState({
        open: true,
        message: `No Game loaded! please reload the page or contact us in discord.`,
        severity: "error",
      });
      console.log("no game loaded!");
    } else {
      setAlertState({
        open: true,
        message: `No DICE NFT found in your wallet! please MINT ONE before entering the DeMonopoly world.`,
        severity: "error",
      });
      console.log("no nft found");
    }
  };

  const clickMint = () => {
    // setReadyEnterGame(true);
    setReadyMint(true)
  }

  const clickBackToEnterGame = () => {
    setReadyMint(false)
    // setReadyEnterGame(false)
  }
  return (
    <main>
      <div
        style={{
          width: "100vw",
          position: "fixed",
          top: "0px",
          paddingBottom: "40px",
        }}
      >
        <MainContainer>
          <WalletContainer>
            {/* <div className="nav-container"> */}
            <div className="logo">
              <img src="cartoon_logo.png" alt="s"></img>
            </div>
            <div className="map-name">
              <span>Location : </span>Metaverse | Farm
            </div>
            <div className="status">
              <span>Status :</span> Gen 1 | Phase 3
            </div>
            <div className="twitter-marker" onClick={onClickTwitter.bind(this)}>
              <img src="twitter_ani.gif" alt=""></img>
            </div>
            <div className="discord-marker" onClick={onClickDiscord.bind(this)}>
              <img src="discord-480.png" alt=""></img>
            </div>
            {/* </div> */}
            <Wallet>
              {wallet ? (
                <WalletAmount>
                  {(balance || 0).toLocaleString()} SOL
                  <ConnectButton />
                </WalletAmount>
              ) : (
                <ConnectButton>Connect Wallet</ConnectButton>
              )}
            </Wallet>
          </WalletContainer>
          <br />
          {readyEnterGame ? null:
          readyMint? null:
          <div style={{height:"70vh", paddingTop:"20vh"}}>
             <button
             style={{
               width: "500px",
               height: "80px",
               marginTop: "10px",
               backgroundColor: "white",
               border: "none",
               borderRadius: "10px",
               boxShadow: "2px 2px 2px rgba(3,3,3,0.5)",
               fontWeight: "900",
               color: "purple",
               fontSize: "20px",
               display:"block",
               margin:"auto"
             }}
             onClick={() => clickEnter()}
           >Enter Game With Your Account</button>
           <button
           style={{
             width: "500px",
             height: "80px",

             backgroundColor: "white",
             border: "none",
             borderRadius: "10px",
             boxShadow: "2px 2px 2px rgba(3,3,3,0.5)",
             fontWeight: "900",
             color: "purple",
             fontSize: "20px",
             display:"block",
             margin:"auto",
             marginTop: "70px",
           }}
           onClick={() => clickMint()}
         >Mint A DICE NFT</button>
         </div>}
          {readyMint ? (
            <div style={{ display: "flex",margin:"auto" }}>
              
              {/* <div
                ref={enterButtonRef}
                style={{width:"340px", height:"330px", margin: "auto 10vw", textAlign: "center", backgroundSize: "contain",backgroundImage:"url('panel.png')", padding:"40px 30px", borderRadius: "20px", marginLeft: "0px"}}
              >
                <div className="enter-game-title" style={{  }}>
                  Enter Demonopoly world with DICE NFT
                </div>
                <button
                  style={{
                    width: "300px",
                    height: "50px",
                    marginTop: "20px",
                    backgroundColor: "white",
                    border: "none",
                    borderRadius: "10px",
                    boxShadow: "2px 2px 2px rgba(3,3,3,0.5)",
                    fontWeight: "900",
                    color: "purple",
                    fontSize: "20px",
                  }}
                  onClick={() => clickEnter()}
                >
                  Enter Game
                </button>
              </div> */}
              <MintContainer ref={mintContainerRef}>
                <DesContainer>
                  <NFT elevation={3}>
                    {/* <img src="./panel.svg" alt=""></img> */}
                    <h2>GENESIS DICE NFT</h2>
                    <br />
                    <div>
                      <Price
                        label={
                          isActive &&
                          whitelistEnabled &&
                          whitelistTokenBalance > 0
                            ? whitelistPrice + " " + priceLabel
                            : price + " " + priceLabel
                        }
                      />
                      <Image src="11_resize.gif" alt="NFT To Mint" />
                    </div>
                    <br />
                    {wallet &&
                      isActive &&
                      whitelistEnabled &&
                      whitelistTokenBalance > 0 &&
                      isBurnToken && (
                        <h3>
                          You own {whitelistTokenBalance} WL mint{" "}
                          {whitelistTokenBalance > 1 ? "tokens" : "token"}.
                        </h3>
                      )}
                    {wallet &&
                      isActive &&
                      whitelistEnabled &&
                      whitelistTokenBalance > 0 &&
                      !isBurnToken && (
                        <h3>You are whitelisted and allowed to mint.</h3>
                      )}
                    {wallet &&
                      isActive &&
                      endDate &&
                      Date.now() < endDate.getTime() && (
                        <Countdown
                          date={toDate(
                            candyMachine?.state?.endSettings?.number
                          )}
                          onMount={({ completed }) =>
                            completed && setIsEnded(true)
                          }
                          onComplete={() => {
                            setIsEnded(true);
                          }}
                          renderer={renderEndDateCounter}
                        />
                      )}
                    {/* {wallet && isActive && (
                      <h3 className="total-mint-text">
                        TOTAL MINTED : {itemsRedeemed} / {itemsAvailable}
                      </h3>
                    )} */}
                    {/* {wallet && isActive && (
                      <BorderLinearProgress
                        variant="determinate"
                        value={100 - (itemsRemaining * 100) / itemsAvailable}
                      />
                    )} */}
                    <br />
                    <MintButtonContainer>
                      {!isActive &&
                      !isEnded &&
                      candyMachine?.state.goLiveDate &&
                      (!isWLOnly || whitelistTokenBalance > 0) ? (
                        <Countdown
                          date={toDate(candyMachine?.state.goLiveDate)}
                          onMount={({ completed }) =>
                            completed && setIsActive(!isEnded)
                          }
                          onComplete={() => {
                            setIsActive(!isEnded);
                          }}
                          renderer={renderGoLiveDateCounter}
                        />
                      ) : !wallet ? (
                        <ConnectButton>Connect Wallet</ConnectButton>
                      ) : !isWLOnly || whitelistTokenBalance > 0 ? (
                        candyMachine?.state.gatekeeper &&
                        wallet.publicKey &&
                        wallet.signTransaction ? (
                          <GatewayProvider
                            wallet={{
                              publicKey:
                                wallet.publicKey ||
                                new PublicKey(CANDY_MACHINE_PROGRAM),
                              //@ts-ignore
                              signTransaction: wallet.signTransaction,
                            }}
                            // // Replace with following when added
                            // gatekeeperNetwork={candyMachine.state.gatekeeper_network}
                            gatekeeperNetwork={
                              candyMachine?.state?.gatekeeper?.gatekeeperNetwork
                            } // This is the ignite (captcha) network
                            /// Don't need this for mainnet
                            clusterUrl={rpcUrl}
                            options={{ autoShowModal: false }}
                          >
                            <MintButton
                              candyMachine={candyMachine}
                              isMinting={isMinting}
                              isActive={isActive}
                              isEnded={isEnded}
                              isSoldOut={isSoldOut}
                              onMint={startMint}
                            />
                          </GatewayProvider>
                        ) : (
                          /*<MintButton
                                                candyMachine={candyMachine}
                                                isMinting={isMinting}
                                                isActive={isActive}
                                                isEnded={isEnded}
                                                isSoldOut={isSoldOut}
                                                onMint={startMint}
                                            />*/
                          <MultiMintButton
                            candyMachine={candyMachine}
                            isMinting={isMinting}
                            isActive={isActive}
                            isEnded={isEnded}
                            isSoldOut={isSoldOut}
                            onMint={startMint}
                            price={whitelistEnabled ? whitelistPrice : price}
                          />
                        )
                      ) : (
                        <h1>Mint is private.</h1>
                      )}
                    </MintButtonContainer>
                    <br />
                    <button
             style={{
               width: "300px",
               height: "50px",
               marginTop: "10px",
               backgroundColor: "white",
               border: "none",
               borderRadius: "10px",
               boxShadow: "2px 2px 2px rgba(3,3,3,0.5)",
               fontWeight: "900",
               color: "purple",
               fontSize: "20px",
             }}
             onClick={() => clickBackToEnterGame()}
           >Back to Menu</button>
                    {wallet && isActive && solanaExplorerLink && (
                      <SolExplorerLink
                        href={solanaExplorerLink}
                        target="_blank"
                      >
                        View on Solscan
                      </SolExplorerLink>
                    )}
                  </NFT>
                </DesContainer>
              </MintContainer>
            </div>
          ) : null}
        </MainContainer>
        <Snackbar
          open={alertState.open}
          autoHideDuration={6000}
          onClose={() => setAlertState({ ...alertState, open: false })}
        >
          <Alert
            onClose={() => setAlertState({ ...alertState, open: false })}
            severity={alertState.severity}
          >
            {alertState.message}
          </Alert>
        </Snackbar>
      </div>
      <UnityGame ref={unityGameRef} />
      <Outlet />
    </main>
  );
};

export default Home;
